<template>
  <q-page style="height: 100vh">
    <!-- <q-img
      src="/statics/loginBanner.jpg"
      style="height: 100vh; position: absolute; width: 100vw"
    >
    </q-img> -->
    <div
      style="min-height: 100vh; position: absolute; min-width: 100vw"
      class="bg-accent"
    ></div>
    <div class="row" align="center" justify="center">
      <div class="col">
        <q-card class="loginCard fixed-center">
          <q-card-section class="">
            <div class="row">
              <div class="col-12">
                <div style="max-width: 280px; max-height: 90%">
                  <q-img
                    src="https://upstreamnz.s3.ap-southeast-2.amazonaws.com/Sustainability+Plans/Oatas+Secondary+Logo-07.svg"
                    spinner-color="white"
                    :ratio="2 / 1"
                    contain
                  />
                </div>
              </div>
            </div>
          </q-card-section>
          <q-card-section>
            <div class="row">
              <div class="col-12" v-if="!$auth.isAuthenticated">
                <q-btn
                  no-caps
                  block
                  color="accent"
                  dark
                  class="full-width"
                  @click="login()"
                  >Login</q-btn
                >
              </div>
              <div class="col-12" v-if="$auth.isAuthenticated">
                <q-btn
                  no-caps
                  block
                  color="primary"
                  dark
                  class="full-width"
                  @click="logout()"
                  >Logout</q-btn
                >
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
    }),
  },
  data: () => ({}),
  watch: {
    $auth: function () {},
  },
  mounted() {},
  methods: {
    // Log the user in
    login() {
      this.$auth.loginWithRedirect();
    },
  },
};
</script>

<style>
.loginCard {
  max-width: 500px;
  width: 90vw;
}

.google-signin-button {
  color: white;
  background-color: red;
  height: 50px;
  font-size: 16px;
  border-radius: 10px;
  padding: 10px 20px 25px 20px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>
